import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { LottieIcon } from '../atoms/icons/lottie_icon';
import { Colors } from '../styles/variables';
export const MissionBadge = ({ item, showNew = false, achievementAnimationData }) => {
    const shouldShowAchievementAnimation = item.isAchieved && achievementAnimationData;
    return (React.createElement("div", { className: css(styles.badge, showNew && styles.badgeWithNew) },
        showNew && item.isNew && React.createElement("span", { className: css(styles.newLabel) }, "\uFF3C NEW! \uFF0F"),
        shouldShowAchievementAnimation ? (React.createElement("div", { className: css(styles.image, styles.achievementAnimationViewport) },
            React.createElement(LottieIcon, { lottieData: achievementAnimationData, classObject: styles.achievementAnimation, loop: false, loopMarkerOnComplete: "loop" }))) : (React.createElement("img", { src: item.isAchieved ? item.completeImageURL : item.incompleteImageURL, alt: "", className: css(styles.image) })),
        React.createElement("span", { className: css(styles.title) }, item.name)));
};
const styles = StyleSheet.create({
    badge: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: 100,
        minWidth: 0,
    },
    badgeWithNew: {
        paddingTop: 21,
    },
    newLabel: {
        position: 'absolute',
        top: 2,
        color: Colors.Accent,
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: 1.6,
        letterSpacing: 0.48,
    },
    image: {
        display: 'block',
        width: '100%',
        maxWidth: 100,
        height: 'auto',
        aspectRatio: '100 / 109',
        objectFit: 'contain',
    },
    achievementAnimationViewport: {
        position: 'relative',
    },
    achievementAnimation: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '150%',
        aspectRatio: '1 / 1',
        transform: 'translate(-50%, calc(-50% + 1px))',
    },
    title: {
        display: 'block',
        minHeight: 38,
        fontSize: 12,
        fontWeight: 'bold',
        lineHeight: 1.6,
        letterSpacing: 0.48,
        textAlign: 'center',
        whiteSpace: 'pre-line',
        color: Colors.Black,
    },
});
